/*! nukumo — 期限つき表示、まとめ買い、一緒に購入・定期便の同時追加、お届け予定日、カートのおすすめ（関連順） */
(function () {
  'use strict';
  if (window.__nkCv) return;
  window.__nkCv = true;
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var pad = function (n) { return (n < 10 ? '0' : '') + n; };
  var money = function (c) { return (window.GB && GB.formatMoney) ? GB.formatMoney(c) : '¥' + Math.round(c / 100).toLocaleString('ja-JP'); };
  var ERR = 'エラーが発生しました。時間をおいて再度お試しください。';
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var cut = function (p, pct) { return p - Math.floor(p * pct / 100); };
  var rootUrl = function () { var GB = window.GB || {}; return ((GB.routes && GB.routes.root) || '/').replace(/\/$/, ''); };
  var postJSON = function (path, body) {
    return fetch(rootUrl() + path, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); });
  };

  function tickEnds() {
    var now = Date.now() / 1000;
    $$('[data-nk-end]').forEach(function (el) {
      var end = parseInt(el.getAttribute('data-nk-end'), 10);
      if (!end) return;
      var left = Math.floor(end - now);
      if (left <= 0) { el.hidden = true; return; }
      $$('[data-nk-cd]', el).forEach(function (cd) {
        var set = function (k, v) { var x = cd.querySelector('[data-nk-cd-' + k + ']'); if (x) x.textContent = v; };
        set('d', Math.floor(left / 86400)); set('h', pad(Math.floor(left % 86400 / 3600))); set('m', pad(Math.floor(left % 3600 / 60))); set('s', pad(left % 60));
      });
    });
  }

  function calc(price, r) {
    var qty = parseInt(r.value, 10) || 1, pct = parseFloat(r.getAttribute('data-pct')) || 0, gift = parseInt(r.getAttribute('data-gift-value'), 10) || 0;
    var full = price * qty;
    return { qty: qty, now: full - Math.floor(full * pct / 10000) * 100, was: full + gift };
  }
  function initBundles(scope) {
    $$('[data-nk-bundles]', scope).forEach(function (box) {
      if (box.__nk) return; box.__nk = true;
      var form = document.getElementById(box.getAttribute('data-form'));
      if (!form) return;
      var pf = form.closest('[data-gb-pf]');
      var price = parseInt(box.getAttribute('data-price'), 10) || 0;
      var radios = $$('input[type="radio"]', box);
      var qtyInput = function () {
        var q = form.querySelector('[name="quantity"]');
        if (!q) { q = document.createElement('input'); q.type = 'hidden'; q.name = 'quantity'; q.value = '1'; form.appendChild(q); }
        return q;
      };
      var render = function () {
        radios.forEach(function (r) {
          var row = r.closest('[data-nk-tier]'); if (!row) return;
          var c = calc(price, r), on = c.was > c.now;
          var n = row.querySelector('[data-nk-tier-now]'); if (n) n.textContent = money(c.now);
          var w = row.querySelector('[data-nk-tier-was]'); if (w) { w.hidden = !on; w.textContent = '単品合計 ' + money(c.was); }
          var s = row.querySelector('[data-nk-tier-save]'); if (s) { s.hidden = !on; s.textContent = money(c.was - c.now) + 'お得'; }
          var e = row.querySelector('[data-nk-tier-each]'); if (e) e.textContent = c.qty > 1 ? '1台あたり ' + money(Math.floor(c.now / c.qty / 100) * 100) : '';
        });
      };
      var sync = function () { var c = radios.filter(function (r) { return r.checked; })[0]; if (c) qtyInput().value = c.value; };
      radios.forEach(function (r) { r.addEventListener('change', sync); });
      document.addEventListener('gb:variant', function (e) {
        if (!e.detail || !e.detail.variant) return;
        if (pf && e.detail.root && e.detail.root !== pf) return;
        price = e.detail.variant.price; render();
      });
      render(); sync();
    });
  }

  /* 一緒に購入・保証・定期便を、本体と一緒にカートへ入れる（まとめ買い特典はカートで自動追加） */
  function extras(form, mainQty) {
    var pdp = form.closest('.gb-pdp') || document;
    var items = [];
    $$('[data-nk-upsell-check]', pdp).forEach(function (c) {
      if (!c.checked) return;
      var row = c.closest('[data-nk-up-row]');
      var sel = row && row.querySelector('[data-nk-up-variant]');
      var q = row && row.querySelector('[data-nk-up-qty]');
      items.push({ id: parseInt(sel ? sel.value : c.getAttribute('data-variant'), 10), quantity: Math.max(1, Math.min(10, parseInt(q && q.value, 10) || 1)) });
    });
    var wa = pdp.querySelector('[data-nk-warranty]');
    if (wa) { var wc = wa.querySelector('[data-nk-warranty-check]'); if (wc && wc.checked) items.push({ id: parseInt(wa.getAttribute('data-variant'), 10), quantity: mainQty || 1 }); }
    var ad = pdp.querySelector('[data-nk-addon]');
    if (ad) { var ck = ad.querySelector('[data-nk-addon-check]'); if (ck && ck.checked) items.push({ id: parseInt(ad.getAttribute('data-variant'), 10), quantity: 1, selling_plan: parseInt(ad.getAttribute('data-plan'), 10) }); }
    return items;
  }

  function initUpsell(scope) {
    $$('[data-nk-up-row]', scope).forEach(function (row) {
      if (row.__nk) return; row.__nk = true;
      var c = row.querySelector('[data-nk-upsell-check]'), sel = row.querySelector('[data-nk-up-variant]'), q = row.querySelector('[data-nk-up-qty]');
      var out = row.querySelector('[data-nk-up-price]'), was = row.querySelector('[data-nk-up-was]');
      var pct = parseInt(row.getAttribute('data-pct'), 10) || 0;
      var unit = function () { var o = sel && sel.options[sel.selectedIndex]; return parseInt(o ? o.getAttribute('data-price') : row.getAttribute('data-price'), 10) || 0; };
      var qty = function () { var n = Math.max(1, Math.min(10, parseInt(q && q.value, 10) || 1)); if (q) q.value = n; return n; };
      var render = function () { var n = qty(), u = unit(); if (out) out.textContent = '+' + money(cut(u, pct) * n); if (was) was.textContent = money(u * n); };
      var pick = function () { if (c) c.checked = true; render(); };
      if (sel) sel.addEventListener('change', function () { if (c) c.setAttribute('data-variant', sel.value); pick(); });
      if (q) q.addEventListener('change', pick);
      $$('[data-nk-up-minus], [data-nk-up-plus]', row).forEach(function (b) {
        b.addEventListener('click', function () { if (!q) return; q.value = (parseInt(q.value, 10) || 1) + (b.hasAttribute('data-nk-up-plus') ? 1 : -1); pick(); });
      });
      render();
    });
  }

  function initForms(scope) {
    $$('.gb-pdp form[data-gb-product-form]', scope).forEach(function (form) {
      if (form.__nkx) return; form.__nkx = true;
      form.addEventListener('submit', function (e) {
        if (!window.fetch) return;
        var q0 = form.querySelector('[name="quantity"]');
        var extra = extras(form, q0 ? (parseInt(q0.value, 10) || 1) : 1);
        if (!extra.length) return;
        e.preventDefault(); e.stopImmediatePropagation();
        var btn = form.querySelector('[data-gb-submit]');
        if (btn && (btn.disabled || btn.getAttribute('aria-busy') === 'true')) return;
        var err = form.querySelector('[data-gb-error]');
        if (err) { err.hidden = true; err.textContent = ''; }
        var items = [{ id: parseInt(form.querySelector('[name="id"]').value, 10), quantity: q0 ? (parseInt(q0.value, 10) || 1) : 1 }].concat(extra);
        var GB = window.GB || {};
        if (btn) btn.setAttribute('aria-busy', 'true');
        postJSON('/cart/add.js', { items: items }).then(function () {
          if (GB.cartType === 'drawer' && GB.cart && GB.cart.drawer) return GB.cart.refresh().then(function () { GB.cart.open(btn); });
          window.location.href = (GB.routes && GB.routes.cart) || '/cart';
        }).catch(function (d) {
          if (err) { err.textContent = (d && (d.description || d.message)) || ERR; err.hidden = false; }
        }).then(function () { if (btn) btn.removeAttribute('aria-busy'); });
      }, true);
    });
  }

  function initEta(scope) {
    $$('[data-nk-eta]', scope).forEach(function (el) {
      var min = parseInt(el.getAttribute('data-min'), 10), max = parseInt(el.getAttribute('data-max'), 10);
      if (isNaN(min)) return;
      if (isNaN(max) || max < min) max = min;
      var cutoff = parseInt(el.getAttribute('data-cutoff'), 10), biz = el.getAttribute('data-bizdays') === 'true';
      var jst = new Date(Date.now() + 9 * 3600 * 1000);
      var base = new Date(Date.UTC(jst.getUTCFullYear(), jst.getUTCMonth(), jst.getUTCDate()));
      if (!isNaN(cutoff) && cutoff > 0 && jst.getUTCHours() >= cutoff) base.setUTCDate(base.getUTCDate() + 1);
      var add = function (n) { var d = new Date(base.getTime()), i = 0; while (i < n) { d.setUTCDate(d.getUTCDate() + 1); var w = d.getUTCDay(); if (!biz || (w !== 0 && w !== 6)) i++; } return d; };
      var wd = '日月火水木金土';
      var f = function (d) { return (d.getUTCMonth() + 1) + '月' + d.getUTCDate() + '日(' + wd.charAt(d.getUTCDay()) + ')'; };
      var out = el.querySelector('[data-nk-eta-out]'); if (!out) return;
      out.textContent = f(add(min)) + '〜' + f(add(max));
      el.hidden = false;
    });
  }

  /* カート（ドロワー）：カートの商品に関連が高い順で「一緒にいかがですか？」を表示（特典・プレゼントの行は数えない） */
  var CUP;
  function cupData() {
    if (CUP !== undefined) return CUP;
    var el = document.querySelector('[data-nk-cup-json]');
    try { CUP = el ? JSON.parse(el.textContent) : null; } catch (e) { CUP = null; }
    return CUP;
  }
  function renderCartUp(c) {
    var box = document.querySelector('[data-nk-cup]'), d = cupData();
    if (!box || !d || !c) return;
    var ship = document.querySelector('[data-nk-ship]');
    if (ship && d.free) {
      var rest = d.free - (c.total_price || 0);
      ship.hidden = !c.item_count;
      ship.classList.toggle('is-free', rest <= 0);
      ship.innerHTML = rest > 0 ? 'あと<b>' + money(rest) + '</b>で送料無料（5,000円以上で送料無料）' : '送料無料の対象です';
    }
    var list = box.querySelector('[data-nk-cup-list]');
    var bought = [], inCart = {};
    (c.items || []).forEach(function (it) {
      var p = it.properties || {};
      if (p._nk_bundle || p._nk_gift || p['特典']) return;
      inCart[it.product_id] = true; bought.push(it.product_id);
    });
    var hasMain = (d.main || []).some(function (id) { return inCart[id]; });
    var rank = function (pid) {
      var best = 999;
      bought.forEach(function (b) { var r = (d.rel || {})[b]; if (r) { var i = r.indexOf(pid); if (i > -1 && i < best) best = i; } });
      return best;
    };
    var items = (d.items || []).filter(function (p) { return !inCart[p.id] && (p.variants || []).some(function (v) { return v.available; }); })
      .map(function (p, i) { return { p: p, i: i, r: rank(p.id) }; })
      .sort(function (a, b) { return a.r - b.r || a.i - b.i; })
      .map(function (x) { return x.p; });
    if (!c.item_count || !items.length) { box.hidden = true; list.innerHTML = ''; return; }
    list.innerHTML = items.map(function (p) {
      var vs = p.variants.filter(function (v) { return v.available; });
      var pct = hasMain ? (p.pct || 0) : 0, price = vs[0].price;
      var sel = vs.length > 1
        ? '<select class="nk-up__select" data-nk-cup-var aria-label="' + esc(p.title) + 'の種類">' + vs.map(function (v) { return '<option value="' + v.id + '" data-price="' + v.price + '">' + esc(v.label || '') + '</option>'; }).join('') + '</select>'
        : '<input type="hidden" data-nk-cup-var value="' + vs[0].id + '">';
      return '<div class="nk-cup__row" data-nk-cup-row data-pct="' + pct + '">' +
        '<a class="nk-cup__img" href="' + esc(p.url) + '">' + (p.img ? '<img src="' + esc(p.img) + '" alt="" width="56" height="56" loading="lazy">' : '') + '</a>' +
        '<span class="nk-cup__txt"><b><a href="' + esc(p.url) + '">' + esc(p.title) + '</a></b>' + (p.note ? '<small>' + esc(p.note) + '</small>' : '') + sel + '</span>' +
        '<span class="nk-cup__side"><span data-nk-cup-price>' + (pct ? '<s>' + money(price) + '</s><b>' + money(cut(price, pct)) + '</b>' : '<b>' + money(price) + '</b>') + '</span>' +
        '<button type="button" class="gb-btn gb-btn--ghost nk-cup__add" data-nk-cup-add>追加</button></span></div>';
    }).join('');
    box.hidden = false;
  }
  function patchCart() {
    var C = window.GB && window.GB.cart;
    if (!C || C.__nkCup || typeof C.render !== 'function') return;
    C.__nkCup = true;
    var orig = C.render;
    C.render = function (c) { orig.call(this, c); try { renderCartUp(c); } catch (e) {} };
    if (C.state) renderCartUp(C.state);
  }
  document.addEventListener('change', function (e) {
    var s = e.target.closest && e.target.closest('select[data-nk-cup-var]');
    if (!s) return;
    var row = s.closest('[data-nk-cup-row]'), o = s.options[s.selectedIndex];
    var p = parseInt(o && o.getAttribute('data-price'), 10) || 0, pct = parseInt(row.getAttribute('data-pct'), 10) || 0;
    var out = row.querySelector('[data-nk-cup-price]');
    if (out) out.innerHTML = pct ? '<s>' + money(p) + '</s><b>' + money(cut(p, pct)) + '</b>' : '<b>' + money(p) + '</b>';
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-nk-cup-add]');
    if (!b || b.getAttribute('aria-busy') === 'true') return;
    e.preventDefault();
    var v = b.closest('[data-nk-cup-row]').querySelector('[data-nk-cup-var]'), GB = window.GB || {};
    b.setAttribute('aria-busy', 'true');
    postJSON('/cart/add.js', { items: [{ id: parseInt(v.value, 10), quantity: 1 }] })
      .then(function () { return GB.cart && GB.cart.refresh ? GB.cart.refresh() : null; })
      .catch(function (d) { if (GB.cart && GB.cart.error) GB.cart.error((d && (d.description || d.message)) || ERR); })
      .then(function () { b.removeAttribute('aria-busy'); });
  });
  patchCart();

  function boot(scope) { initBundles(scope); initUpsell(scope); initForms(scope); initEta(scope); tickEnds(); }
  var started = false;
  function start() { patchCart(); boot(document); if (!started) { started = true; setInterval(tickEnds, 1000); } }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();